import { Check, X } from "lucide-react";
import { Button } from "../components/ui/button";

const AFFILIATE_URL = "https://bc072hg2p7rncg20qs5ev03po2.hop.clickbank.net";

export const Comparison = () => {
  const comparisons = [
    { feature: "Burns fat naturally", citrus: true, others: false },
    { feature: "No strict dieting required", citrus: true, others: false },
    { feature: "No exhausting exercise", citrus: true, others: false },
    { feature: "Boosts energy all day", citrus: true, others: false },
    { feature: "Reduces cravings", citrus: true, others: false },
    { feature: "100% natural ingredients", citrus: true, others: false },
    { feature: "FDA registered facility", citrus: true, others: false },
    { feature: "180-day money back guarantee", citrus: true, others: false },
    { feature: "No jitters or crashes", citrus: true, others: false },
    { feature: "Clinically researched", citrus: true, others: false },
  ];

  return (
    <section data-testid="comparison-section" className="py-16 md:py-20 bg-[#F9F7F2]" aria-labelledby="comparison-heading">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <a href={AFFILIATE_URL} target="_blank" rel="noopener noreferrer" className="block">
          <div className="text-center mb-12 cursor-pointer">
            <span className="inline-block bg-[#FFF5E6] text-[#FF6B00] text-xs font-bold px-4 py-1.5 rounded-full mb-4 uppercase tracking-wider">
              See The Difference
            </span>
            <h2 id="comparison-heading" className="text-3xl md:text-4xl lg:text-5xl font-black text-[#1A1C19] mb-4" style={{ fontFamily: "Fraunces, serif" }}>
              Why The <span className="text-[#FF6B00]">"Orange Peel Trick"</span> Wins
            </h2>
            <p className="text-lg text-[#4A5043] max-w-2xl mx-auto">
              See how this method compares to other weight loss approaches
            </p>
          </div>
        </a>

        <a href={AFFILIATE_URL} target="_blank" rel="noopener noreferrer" className="block">
          <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-[#FFE4CC] cursor-pointer hover:shadow-2xl transition-shadow">
            {/* Header */}
            <div className="grid grid-cols-3 bg-gradient-to-r from-[#FF6B00] to-[#FF8C00] text-white">
              <div className="p-4 font-bold text-sm md:text-base">Feature</div>
              <div className="p-4 font-bold text-center text-sm md:text-base border-l border-white/20">
                <span className="hidden sm:inline">Orange Peel Trick</span>
                <span className="sm:hidden">This Method</span>
              </div>
              <div className="p-4 font-bold text-center text-sm md:text-base border-l border-white/20">
                <span className="hidden sm:inline">Other Methods</span>
                <span className="sm:hidden">Others</span>
              </div>
            </div>

            {/* Rows */}
            {comparisons.map((item, index) => (
              <div key={index} className={`grid grid-cols-3 ${index % 2 === 0 ? 'bg-white' : 'bg-[#FFF9F5]'} border-t border-[#FFE4CC]`}>
                <div className="p-4 text-[#4A5043] text-sm md:text-base flex items-center">
                  {item.feature}
                </div>
                <div className="p-4 flex items-center justify-center border-l border-[#FFE4CC]">
                  {item.citrus ? (
                    <div className="w-8 h-8 bg-[#E8F5E9] rounded-full flex items-center justify-center">
                      <Check size={20} className="text-[#2E7D32]" />
                    </div>
                  ) : (
                    <div className="w-8 h-8 bg-[#FFEBEE] rounded-full flex items-center justify-center">
                      <X size={20} className="text-[#C41E3A]" />
                    </div>
                  )}
                </div>
                <div className="p-4 flex items-center justify-center border-l border-[#FFE4CC]">
                  {item.others ? (
                    <div className="w-8 h-8 bg-[#E8F5E9] rounded-full flex items-center justify-center">
                      <Check size={20} className="text-[#2E7D32]" />
                    </div>
                  ) : (
                    <div className="w-8 h-8 bg-[#FFEBEE] rounded-full flex items-center justify-center">
                      <X size={20} className="text-[#C41E3A]" />
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </a>

        {/* CTA */}
        <div className="mt-10 text-center">
          <a href={AFFILIATE_URL} target="_blank" rel="noopener noreferrer" data-testid="comparison-cta">
            <Button className="bg-gradient-to-r from-[#FF6B00] to-[#FF8C00] hover:from-[#E65C00] hover:to-[#FF6B00] text-white font-black rounded-full px-10 py-5 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 text-lg uppercase tracking-wide">
              👉 Try The Orange Peel Trick Risk-Free Today
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Comparison;
